import Cookies from 'js-cookie'
import { cookiesDomain } from '@/utils/token'

const AFTER_LOGIN_FROM_SOURCE_KEY = '__after_login_from_source'

/**
 * afterLogin 的 fromSource 需要兼容两套登录现场：
 * 1. ERP/epaas 内嵌时域名不一致，只能落当前页 sessionStorage
 * 2. 普通登录跳转需要跨页读取，继续走根域 cookie
 */
const getIsErpContainer = async (): Promise<boolean> => {
    try {
        const [isEpaas, isErp] = await Promise.all([window.jst_core.env.isEpaas(), window.jst_core.env.isErp()])

        return Boolean(isEpaas || isErp)
    } catch (error) {
        console.error('getIsErpContainer_failed', error)
        return false
    }
}

/**
 * 只缓存 afterLogin 返回的 fromSource 字符串，不承接 inviteId 等其它字段。
 */
export const setAfterLoginFromSource = async (fromSource: string): Promise<void> => {
    if (!fromSource) {
        return
    }

    if (await getIsErpContainer()) {
        sessionStorage.setItem(AFTER_LOGIN_FROM_SOURCE_KEY, fromSource)
        return
    } else {
        Cookies.set(AFTER_LOGIN_FROM_SOURCE_KEY, fromSource, {
            domain: cookiesDomain,
        })
    }
}

/**
 * 读取时仍按当前运行环境选存储源，避免 ERP 内嵌误读到主站 cookie。
 */
export const getAfterLoginFromSource = async (): Promise<string> => {
    if (await getIsErpContainer()) {
        return sessionStorage.getItem(AFTER_LOGIN_FROM_SOURCE_KEY) || ''
    }

    return Cookies.get(AFTER_LOGIN_FROM_SOURCE_KEY) || ''
}

/**
 * 退出登录后需要同步清掉 fromSource，避免下一个登录态继续复用上一位用户的来源标记。
 */
export const clearAfterLoginFromSource = async (): Promise<void> => {
    if (await getIsErpContainer()) {
        sessionStorage.removeItem(AFTER_LOGIN_FROM_SOURCE_KEY)
        return
    }

    Cookies.remove(AFTER_LOGIN_FROM_SOURCE_KEY, {
        domain: cookiesDomain,
    })
}
